<template>
  <m-card3
      :image="product.thumbnail"
      :alt="product.name"
      class="product-card-207 "
  >
    <template v-if="isProductActive(product)">
      <p class="p-0 m-0">{{ contentSlicer(product.name, 55) }}</p>

      <div class=""></div>

      <shopping-cart-quantity-manager300 class="p-0 m-0 my-1" v-for="subProduct in subProducts(product)" :product="product"
                                         :sub-product="subProduct"/>
    </template>
    <template v-else>
      <div class="text-center" dir="rtl">
        <p v-t="`product.timing`"></p>
      </div>
    </template>
  </m-card3>
</template>

<script>
import {shoppingCartFunctions} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";
import mCard3 from "../../Cards/Card3.vue";
import mA from "../../Tags/A";
import mProductCardQuantityManager1 from "../../Product/QuantityManager/Card/ProductCardQuantityManager1";
import mProductPrice200 from "../../Product/ProductPrice200";
import mProductOffer1 from "../../Product/ProductOffer/ProductOffer1";
import {OfferProps} from "../ProductOffer/ProductOfferProps";
import {
  addFeatureToProduct,
  featureCategories,
  findFeatureWithSelectedName,
  groupByType,
  productFeatureValue,
  removeChildFeature,
  subProducts,
  removeEmptyGroups,
  sortedFeaturesMethod,
} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import {contentSlicer} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ContentFunctions";
import ShoppingCartQuantityManager300 from "../../Product/ShoppingCartQuantityManager300.vue";

export default {
  name: "ProductCard3_variation",
  components: {
    ShoppingCartQuantityManager300,
    mCard3,
    mA,
    mProductCardQuantityManager1,
    mProductPrice200,
    mProductOffer1,
  },
  props: {
    product: {},
    ...OfferProps,
  },
  methods: {
    contentSlicer,
    ...shoppingCartFunctions,
    findFeatureWithSelectedName,
    subProducts,
  },
};
</script>

<style scoped>
.card207-icon {
  width: 36px;
  height: 32px;
  object-fit: cover;
  border-radius: 7px;
}
</style>
